// modules are defined as an array
// [ module function, map of requires ]
//
// map of requires is short require name -> numeric require
//
// anything defined in a previous bundle is accessed via the
// orig method which is the require for previous bundles

(function (modules, entry, mainEntry, parcelRequireName, globalName) {
  /* eslint-disable no-undef */
  var globalObject =
    typeof globalThis !== 'undefined'
      ? globalThis
      : typeof self !== 'undefined'
      ? self
      : typeof window !== 'undefined'
      ? window
      : typeof global !== 'undefined'
      ? global
      : {};
  /* eslint-enable no-undef */

  // Save the require from previous bundle to this closure if any
  var previousRequire =
    typeof globalObject[parcelRequireName] === 'function' &&
    globalObject[parcelRequireName];

  var cache = previousRequire.cache || {};
  // Do not use `require` to prevent Webpack from trying to bundle this call
  var nodeRequire =
    typeof module !== 'undefined' &&
    typeof module.require === 'function' &&
    module.require.bind(module);

  function newRequire(name, jumped) {
    if (!cache[name]) {
      if (!modules[name]) {
        // if we cannot find the module within our internal map or
        // cache jump to the current global require ie. the last bundle
        // that was added to the page.
        var currentRequire =
          typeof globalObject[parcelRequireName] === 'function' &&
          globalObject[parcelRequireName];
        if (!jumped && currentRequire) {
          return currentRequire(name, true);
        }

        // If there are other bundles on this page the require from the
        // previous one is saved to 'previousRequire'. Repeat this as
        // many times as there are bundles until the module is found or
        // we exhaust the require chain.
        if (previousRequire) {
          return previousRequire(name, true);
        }

        // Try the node require function if it exists.
        if (nodeRequire && typeof name === 'string') {
          return nodeRequire(name);
        }

        var err = new Error("Cannot find module '" + name + "'");
        err.code = 'MODULE_NOT_FOUND';
        throw err;
      }

      localRequire.resolve = resolve;
      localRequire.cache = {};

      var module = (cache[name] = new newRequire.Module(name));

      modules[name][0].call(
        module.exports,
        localRequire,
        module,
        module.exports,
        globalObject
      );
    }

    return cache[name].exports;

    function localRequire(x) {
      var res = localRequire.resolve(x);
      return res === false ? {} : newRequire(res);
    }

    function resolve(x) {
      var id = modules[name][1][x];
      return id != null ? id : x;
    }
  }

  function Module(moduleName) {
    this.id = moduleName;
    this.bundle = newRequire;
    this.exports = {};
  }

  newRequire.isParcelRequire = true;
  newRequire.Module = Module;
  newRequire.modules = modules;
  newRequire.cache = cache;
  newRequire.parent = previousRequire;
  newRequire.register = function (id, exports) {
    modules[id] = [
      function (require, module) {
        module.exports = exports;
      },
      {},
    ];
  };

  Object.defineProperty(newRequire, 'root', {
    get: function () {
      return globalObject[parcelRequireName];
    },
  });

  globalObject[parcelRequireName] = newRequire;

  for (var i = 0; i < entry.length; i++) {
    newRequire(entry[i]);
  }

  if (mainEntry) {
    // Expose entry point to Node, AMD or browser globals
    // Based on https://github.com/ForbesLindesay/umd/blob/master/template.js
    var mainExports = newRequire(mainEntry);

    // CommonJS
    if (typeof exports === 'object' && typeof module !== 'undefined') {
      module.exports = mainExports;

      // RequireJS
    } else if (typeof define === 'function' && define.amd) {
      define(function () {
        return mainExports;
      });

      // <script>
    } else if (globalName) {
      this[globalName] = mainExports;
    }
  }
})({"3Nrpv":[function(require,module,exports,__globalThis) {
var _quickAddScss = require("../scss/quick-add.scss"); // import { ModalDialog } from './global';
 // if (!customElements.get('quick-add-modal')) {
 //   customElements.define(
 //     'quick-add-modal',
 //     class QuickAddModal extends ModalDialog {
 //       constructor() {
 //         super();
 //         this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');
 //         this.addEventListener('product-info:loaded', ({ target }) => {
 //           target.addPreProcessCallback(this.preprocessHTML.bind(this));
 //         });
 //       }
 //       hide(preventFocus = false) {
 //         const cartNotification = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
 //         if (cartNotification) cartNotification.setActiveElement(this.openedBy);
 //         this.modalContent.innerHTML = '';
 //         if (preventFocus) this.openedBy = null;
 //         super.hide();
 //       }
 //       show(opener) {
 //         opener.setAttribute('aria-disabled', true);
 //         opener.classList.add('loading');
 //         opener.querySelector('.loading__spinner').classList.remove('hidden');
 //         fetch(opener.getAttribute('data-product-url'))
 //           .then((response) => response.text())
 //           .then((responseText) => {
 //             const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
 //             const productElement = responseHTML.querySelector('product-info');
 //             this.preprocessHTML(productElement);
 //             HTMLUpdateUtility.setInnerHTML(this.modalContent, productElement.outerHTML);
 //             if (window.Shopify && Shopify.PaymentButton) {
 //               Shopify.PaymentButton.init();
 //             }
 //             if (window.ProductModel) window.ProductModel.loadShopifyXR();
 //             super.show(opener);
 //           })
 //           .finally(() => {
 //             opener.removeAttribute('aria-disabled');
 //             opener.classList.remove('loading');
 //             opener.querySelector('.loading__spinner').classList.add('hidden');
 //           });
 //       }
 //       preprocessHTML(productElement) {
 //         productElement.classList.forEach((classApplied) => {
 //           if (classApplied.startsWith('color-') || classApplied === 'gradient')
 //             this.modalContent.classList.add(classApplied);
 //         });
 //         this.preventDuplicatedIDs(productElement);
 //         this.removeDOMElements(productElement);
 //         this.removeGalleryListSemantic(productElement);
 //         this.updateImageSizes(productElement);
 //         this.preventVariantURLSwitching(productElement);
 //       }
 //       preventVariantURLSwitching(productElement) {
 //         productElement.setAttribute('data-update-url', 'false');
 //       }
 //       removeDOMElements(productElement) {
 //         const pickupAvailability = productElement.querySelector('pickup-availability');
 //         if (pickupAvailability) pickupAvailability.remove();
 //         const productModal = productElement.querySelector('product-modal');
 //         if (productModal) productModal.remove();
 //         const modalDialog = productElement.querySelectorAll('modal-dialog');
 //         if (modalDialog) modalDialog.forEach((modal) => modal.remove());
 //       }
 //       preventDuplicatedIDs(productElement) {
 //         const sectionId = productElement.dataset.section;
 //         const oldId = sectionId;
 //         const newId = `quickadd-${sectionId}`;
 //         productElement.innerHTML = productElement.innerHTML.replaceAll(oldId, newId);
 //         Array.from(productElement.attributes).forEach((attribute) => {
 //           if (attribute.value.includes(oldId)) {
 //             productElement.setAttribute(attribute.name, attribute.value.replace(oldId, newId));
 //           }
 //         });
 //         productElement.dataset.originalSection = sectionId;
 //       }
 //       removeGalleryListSemantic(productElement) {
 //         const galleryList = productElement.querySelector('[id^="Slider-Gallery"]');
 //         if (!galleryList) return;
 //         galleryList.setAttribute('role', 'presentation');
 //         galleryList.querySelectorAll('[id^="Slide-"]').forEach((li) => li.setAttribute('role', 'presentation'));
 //       }
 //       updateImageSizes(productElement) {
 //         const product = productElement.querySelector('.product');
 //         const desktopColumns = product?.classList.contains('product--columns');
 //         if (!desktopColumns) return;
 //         const mediaImages = product.querySelectorAll('.product__media img');
 //         if (!mediaImages.length) return;
 //         let mediaImageSizes =
 //           '(min-width: 1000px) 715px, (min-width: 750px) calc((100vw - 11.5rem) / 2), calc(100vw - 4rem)';
 //         if (product.classList.contains('product--medium')) {
 //           mediaImageSizes = mediaImageSizes.replace('715px', '605px');
 //         } else if (product.classList.contains('product--small')) {
 //           mediaImageSizes = mediaImageSizes.replace('715px', '495px');
 //         }
 //         mediaImages.forEach((img) => img.setAttribute('sizes', mediaImageSizes));
 //       }
 //     }
 //   );
 // }

},{"../scss/quick-add.scss":"eKM82"}],"eKM82":[function() {},{}]},["3Nrpv"], "3Nrpv", "parcelRequire94c2")

//# sourceMappingURL=quick-add.js.map
